// extracted by mini-css-extract-plugin
module.exports = {"noticeButtons":"AdminNotice_noticeButtons___JaDv"};